import { Box, Button, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import imGoogle from './google.svg';
import imMicrosoft from './microsoft.svg';

interface IProps {
	hasGoogle: boolean;
	hasMicrosoft: boolean;
	login: (provider: 'google' | 'microsoft') => Promise<void>;
}

export default function SocialLoginForm(props: IProps) {
	const { t } = useTranslation();
	return (
		<Box>
			<Box mb={6}>
				<Box display="flex" flexDir="column">
					{props.hasGoogle ? (
						<Button
							w="full"
							leftIcon={<Image w={4} h={4} src={imGoogle} />}
							onClick={() => props.login('google')}
							mb={4}
						>
							{t('Login with Google')}
						</Button>
					) : null}

					{props.hasMicrosoft ? (
						<Button
							// bg="blackAlpha.900"
							// colorScheme="blackAlpha"
							w="full"
							leftIcon={<Image w={4} h={4} src={imMicrosoft} />}
							onClick={() => props.login('microsoft')}
						>
							{t('Login with Microsoft')}
						</Button>
					) : null}
				</Box>
			</Box>
		</Box>
	);
}
